import React, { useEffect, useState } from 'react'
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import UserProfileDetails from '../pages/AdminPages/AllCellCastUser/UserProfileDetail/UserProfileDetails'
import PurchaseCredits from '../pages/Common/PurchaseCredits'
import AccountsPage from '../pages/UserPages/accounts/AccountsPageWrapper'
import { APIWrapper } from '../pages/UserPages/api-integration/ApiIntegration'
import Subscribers from '../pages/UserPages/Contacts/AllContactsList/Subscribers'
import ContactListBySegment from '../pages/UserPages/Contacts/Segments/ContactListBySegment'
import SegmentList from '../pages/UserPages/Contacts/Segments/SegmentList'
import ContactListByTag from '../pages/UserPages/Contacts/Tags/ContactListByTag'
import TagsList from '../pages/UserPages/Contacts/Tags/TagsList'
import { CustomOptOutWrapper } from '../pages/UserPages/custom-opt-out/CustomOptOutWrapper'
import { DashboardWrapper } from '../pages/UserPages/dashboard/DashboardWrapper'
import { DashboardWrapper as DashboardWrapperV2 } from '../pages/UserPages/dashboard-v2/DashboardWrapper'
import { DashboardWrapper as DashboardProWrapper } from '../pages/UserPages/dashboard-pro/DashboardWrapper'
import { DraftWrapper } from '../pages/UserPages/Draft/DraftPageWrapper'
import { EmailToSmsWrapper } from '../pages/UserPages/email-to-sms/EmailToSms'
import { InboxWrapper } from '../pages/UserPages/inbox/Inbox'
import {InboxConditionalWrapper} from '../pages/UserPages/inbox/InboxConditionalWrapper'
import { IntegrationWrapper } from '../pages/UserPages/Integration/IntegrationPage'
import { IntegrationPageDetailWrapper } from '../pages/UserPages/Integration/IntegrationPageDetail'
import { KnowledgeBaseWrapper } from '../pages/UserPages/knowledge-base/KnowledgeBase'
import CreateLandingPage from '../pages/UserPages/LandingPage/CreateLandingPage'
import LandingPageList from '../pages/UserPages/LandingPage/LandingPageList'

import { MenuTestPage } from '../pages/UserPages/MenuTestPage'
import CreateScratch from '../pages/UserPages/MyTemplate/CreateScratch/CreateScratch'
import MyTemplateListing from '../pages/UserPages/MyTemplate/MyTemplateListing'
import OurTemplates from '../pages/UserPages/MyTemplate/OurTemplates/OurTemplates'
import { NewMessageStepperWrapper } from '../pages/UserPages/new-message/WizardStep/NewMessageStepperWrapper'
import OptOutLists from '../pages/UserPages/Opt_out/OptOutLists'
import OptOutPopup from '../pages/UserPages/Opt_out/OptOutPopup'

import ReportsAnalyticsInsightMessages from '../pages/UserPages/reports-analytics/InsightMessages'
import ReportsAnalyticsBulkMessages from '../pages/UserPages/reports-analytics/BulkMessages'
import ReportsAnalyticsActivityLogsPage from '../pages/UserPages/reports-analytics/ActivityLogsPage'

import ReportsAnalyticsQuickMessage from '../pages/UserPages/reports-analytics/QuickMessagesV2'
// import ReportsAnalyticsEmailToSmsMessage from '../pages/UserPages/reports-analytics/EmailToSmsMessages'
// import ReportsAnalyticsQuickApiMessage from '../pages/UserPages/reports-analytics/QuickApiMessagesV2'

import ReportsAnalyticsFileSchedulerMessage from '../pages/UserPages/reports-analytics/FileSchedulers/FileSchedulerMessages'
import ReportsAnalyticsShortLink from '../pages/UserPages/reports-analytics/ShortLinkPage'
import ReportsAnalyticsLandingPageLink from '../pages/UserPages/reports-analytics/LandingPage'
import ReportSchedulerDetail from '../pages/UserPages/reports-analytics/FileSchedulers/FileSchedulerDetail'

import { SupporTicketsWrapper } from '../pages/UserPages/support-tickets/SupportTicketPage'
import { OnboardingCheck, SuspensedView } from '../Utils/AllHelperFunctions'

import { RoutePaths } from './RoutePath'
import { NewPurchaseCreditModalWrapper } from '../pages/Common/NewPurchaseCreditModalWrapper'
import EmailToSms from '../pages/UserPages/EmailToSms/EmailToSms'
import SavedCampaign from '../pages/UserPages/MyTemplate/SavedCampaign'
import ReportPageWrapper from '../pages/UserPages/reports-analytics/ReportPageWrapper'
import AutomationWrapper from '../pages/UserPages/automation/Automation'
import FlowWrapper from '../pages/UserPages/automation/FlowWrapper'
import Reviews from '../pages/UserPages/Reviews/review'
import ContactPage from '../pages/UserPages/Contacts/AllContacts'
import ContactUnsubscribePage from '../pages/UserPages/Contacts/Unsubscribe'
import ContactForm from '../pages/UserPages/Contacts/Form/List'
import ListPage from '../pages/UserPages/Contacts/List/ListData/List'
import ListDetailPage from '../pages/UserPages/Contacts/List/Detail/Detail'

// Sub Account Page
import SubAccountOwnerList from '../pages/UserPages/sub-client/List/List'
import SubAccountOwnerDetail from '../pages/UserPages/sub-client/Detail/Detail'
import ReportPageSchedulerWrapper from '../pages/UserPages/reports-analytics/ReportPageSchedulerWrapper'

// File Scheduler
import FileScheduler from '../pages/UserPages/file-scheduler/FileSchedulerList'
import FileSchedulerCreate from '../pages/UserPages/file-scheduler/FileScheduler'
import UploadHistory from '../pages/UserPages/Contacts/UploadHistory/UploadHistory'
import SenderIdWrapper from '../pages/UserPages/sender-id/SenderIdWrapper'
import HowToVideosPage from '../pages/UserPages/how-to-videos/HowToVideosPage'
import HowToVideoDetailPage from '../pages/UserPages/how-to-videos/HowToVideoDetailPage'
// import WalletCardReport from '../pages/UserPages/wallet-card/WalletCardReport'
import WalletCardList from '../pages/UserPages/wallet-card/WalletCardList'
import { WalletCard } from '../pages/UserPages/wallet-card/WalletCard'
import WalletCardSuccessPage from '../pages/UserPages/wallet-card/components/WalletCardSuccessPage/WalletCardSuccessPage'
import BCardSubscriptionStatus from '../pages/UserPages/wallet-card/BCardSubscriptionStatus'
import { WalletCardPublic } from '../pages/UserPages/wallet-card/WalletCardPublic'
import { ContactCollection } from '../pages/UserPages/contact-collection/ContactCollection'
import { DetailWalletCardReport } from '../pages/UserPages/detail-wallet-card-report/DetailWalletCardReport'
import PromoActionList from '../pages/UserPages/promo-action/PromoActionList'
import SavedSequence from '../pages/UserPages/Flow/FlowList/FlowList'
import WorkFlow from '../pages/UserPages/Flow/WorkFlow/WorkFlow'
import FlowReport from '../pages/UserPages/reports-analytics/FlowReport'
import FlowListReport from '../pages/UserPages/reports-analytics/FlowListReport'
import FlowLogs from '../pages/UserPages/Flow/Logs/FlowLogs'
import FlowInstance from '../pages/UserPages/Flow/Logs/FlowInstance'
import EventLogsDetail from '../pages/UserPages/Flow/Logs/EventLogsDetail'
import { useSelector } from 'react-redux'
import { getAllUserDetails } from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import TeamList from '../pages/UserPages/accounts/SubAccounts/TeamList'
import WalletCardTemplates from '../pages/UserPages/wallet-card-templates/WalletCardTemplates'
import AdminOwnerRoute from './AdminOwnerRoute'
import FlowList from '../pages/UserPages/Flow/FlowList/FlowList'

import RecordList from '../pages/UserPages/contact-collection/RecordList'
import NewContacts from '../pages/UserPages/Contacts/NewContacts'
import useNewNavigation from '../hooks/useNewNavigation'
import DemoPageLeadzApp from '../pages/UserPages/wallet-card/DemoPageLeadzApp'
import GetStartedPage from '../pages/UserPages/wallet-card/GetStartedPage'
import TabContactCollection from '../pages/UserPages/contact-collection/TabContactCollection'
import ThirdPartySignupForm from '../Components/ThirdPartySignupForm'

const UserRoutes = () => {
  const userValues = useSelector(getAllUserDetails)
  const { newNavigation } = useNewNavigation()

  const navigate = useNavigate()
  const redirectUrl = localStorage.getItem('redirectUrl')

  useEffect(() => {
    if (redirectUrl) {
      const userRedirect = redirectUrl;
      navigate(userRedirect, { replace: true })

      localStorage.removeItem('redirectUrl')
      localStorage.removeItem('firstimeLogin')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userValues?._id, redirectUrl])

  return (
    <>
      <Routes>
        <Route element={<MasterLayout />}>
          <Route path='auth/*' element={<Navigate to={'/dashboard'} replace={true} />} />
          <Route path={RoutePaths.dashboard} element={<DashboardWrapper />} />
          <Route path={RoutePaths['dashboard-v2']} element={<DashboardWrapperV2 />} />
          <Route path={RoutePaths['dashboard-pro']} element={<DashboardProWrapper />} />
          <Route path={RoutePaths.inbox} element={<InboxConditionalWrapper />} />
          <Route path={RoutePaths.menu} element={<MenuTestPage />} />
          <Route path='/login-external-first/*' element={<ThirdPartySignupForm />} />
          {/* report and analytic route  */}
          <Route
            path={RoutePaths.reportAnalyticInsight}
            element={<ReportsAnalyticsInsightMessages />}
          />
          <Route
            path={RoutePaths.reportAnalyticBulkMessages}
            element={<ReportsAnalyticsBulkMessages />}
          />
          <Route
            path={RoutePaths.reportAnalyticActivityLogs}
            element={<ReportsAnalyticsActivityLogsPage />}
          />

          <Route
            path={RoutePaths.reportAnalyticQuickMessages}
            element={<ReportsAnalyticsQuickMessage />}
          />
          {/* <Route
              path={RoutePaths.reportAnalyticEmailToSmsMessages}
              element={<ReportsAnalyticsEmailToSmsMessage />}
            />
            <Route
              path={RoutePaths.reportAnalyticQuickApiMessages}
              element={<ReportsAnalyticsQuickApiMessage />}
            /> */}

          <Route
            path={RoutePaths.reportAnalyticFileSchedulerMessage}
            element={<ReportsAnalyticsFileSchedulerMessage />}
          />

          <Route
            path={RoutePaths.reportAnalyticShortLink}
            element={<ReportsAnalyticsShortLink />}
          />
          <Route
            path={RoutePaths.reportAnalyticLandingPage}
            element={<ReportsAnalyticsLandingPageLink />}
          />

          <Route path={RoutePaths.schedulerDetail} element={<ReportSchedulerDetail />} />

          <Route path={'eofy/*'} element={<ReportPageWrapper />} />
          <Route path={'scheduler/*'} element={<ReportPageSchedulerWrapper />} />
          {/* <Route path={RoutePaths.emailToSms} element={<EmailToSmsWrapper />} /> */}
          <Route path={RoutePaths.automation} element={<AutomationWrapper />} />
          <Route path={RoutePaths.senderId} element={<SenderIdWrapper />} />
          <Route path={RoutePaths.automationFlow} element={<FlowWrapper />} />
          <Route path={RoutePaths.knowledgeBase} element={<KnowledgeBaseWrapper />} />
          <Route path={RoutePaths.draft} element={<DraftWrapper />} />
          <Route path={RoutePaths.landingPage} element={<LandingPageList />} />
          <Route path={RoutePaths.integration} element={<IntegrationWrapper />} />
          <Route path={RoutePaths.integrationDetail} element={<IntegrationPageDetailWrapper />} />
          <Route path={RoutePaths.api} element={<APIWrapper />} />
          <Route path={RoutePaths.supportTicket} element={<SupporTicketsWrapper />} />

          <Route path={'/New-Template'} element={<CreateScratch />} />
          <Route path='/our-template' element={<OurTemplates />} />
          <Route path='/templates/savedCampaign' element={<SavedCampaign />} />

          {/* feature flow */}
          <Route path={RoutePaths.automationNew} element={<WorkFlow />} />
          <Route path={RoutePaths.automationFlowDetail} element={<WorkFlow />} />
          <Route path={RoutePaths.automationLogs} element={<FlowLogs />} />

          <Route path={RoutePaths.automationFlowInstance} element={<FlowInstance />} />
          <Route path={RoutePaths.automationLogsDetail} element={<EventLogsDetail />} />
          <Route path={RoutePaths.reportAnalyticFlow} element={<FlowListReport />} />
          <Route path={RoutePaths.reportAnalyticFlowReport} element={<FlowReport />} />

          {/* contact  */}
          <Route path={RoutePaths.contactsTag} element={<TagsList />} />
          <Route
            path={RoutePaths.contactsAll}
            element={!!newNavigation ? <NewContacts /> : <ContactPage />}
          />
          <Route path={RoutePaths.contactsForm} element={<ContactForm />} />
          <Route path={RoutePaths.contactsSegments} element={<SegmentList />} />
          <Route path={RoutePaths.contactsUnsubscribe} element={<ContactUnsubscribePage />} />
          <Route path={RoutePaths.contactsList} element={<ListPage />} />
          <Route path={RoutePaths.contactsListDetail} element={<ListDetailPage />} />
          <Route path={RoutePaths.contactsUploadHistory} element={<UploadHistory />} />
          {/* <Route path='/contacts/subscriber' element={<Subscribers />} /> */}

          <Route path='/opt-out' element={<OptOutPopup />} />
          <Route path='/opt-out-list' element={<OptOutLists />} />
          <Route path='/segmentfilterContact' element={<ContactListBySegment />} />
          <Route path='/filterContact' element={<ContactListByTag />} />
          <Route path='/create-langing-page' element={<CreateLandingPage />} />
          <Route path='/landing-page' element={<LandingPageList />} />
          <Route path='/reviews' element={<Reviews />} />
          <Route
            path={RoutePaths.newMessage}
            element={
              <OnboardingCheck>
                <NewMessageStepperWrapper />
              </OnboardingCheck>
            }
          />
          <Route path={RoutePaths.emailToSms} element={<EmailToSms />} />

          {/* sub account  */}
          <Route path={RoutePaths.subAccountUser} element={<SubAccountOwnerList />} />
          <Route path={RoutePaths.subAccountUserDetail} element={<SubAccountOwnerDetail />} />

          {/* File Scheduler */}
          <Route path={RoutePaths.fileScheduler} element={<FileScheduler />} />
          <Route path={RoutePaths.fileSchedulerForm} element={<FileSchedulerCreate />} />

            {/*Help*/}
            <Route path={RoutePaths.howToVideos} element={<HowToVideosPage />} />
            <Route path={RoutePaths.howToVideoDetail} element={<HowToVideoDetailPage />} />

          <Route
            path={RoutePaths.accounts}
            element={
              <SuspensedView>
                <AccountsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/templates/template'
            element={
              <SuspensedView>
                <MyTemplateListing />
              </SuspensedView>
            }
          />
          <Route
            path='custom-opt-out/*'
            element={
              <SuspensedView>
                <CustomOptOutWrapper />
              </SuspensedView>
            }
          />
          <Route
            path={'/accounts/*'}
            element={
              <SuspensedView>
                <AccountsPage />
              </SuspensedView>
            }
          />

          <Route
            path='/user-profile/*'
            element={
              <SuspensedView>
                <UserProfileDetails />
              </SuspensedView>
            }
          />
          <Route path='/topup' element={<NewPurchaseCreditModalWrapper />} />
          <Route path='/wallet-card' element={<WalletCardList />} />
          <Route path='/wallet-card/create' element={<WalletCard />} />
          <Route path='/wallet-card/edit/:cardId' element={<WalletCard />} />
          <Route path='/wallet-card/subscription' element={<BCardSubscriptionStatus />} />
          <Route path='/wallet-card/subscription/activate' element={<BCardSubscriptionStatus />} />
          <Route path='/wallet-card/success/:cardId' element={<WalletCardSuccessPage />} />
          <Route path='/wallet-card/detail/:cardId' element={<WalletCardSuccessPage />} />
          <Route path='/wallet-card/subscription/demo-leadz-app' element={<DemoPageLeadzApp />} />
          <Route path='/wallet-card/subscription/get-started' element={<GetStartedPage />} />
          <Route
            path='/card-templates'
            element={
              <AdminOwnerRoute>
                <WalletCardTemplates />
              </AdminOwnerRoute>
            }
          />
          <Route
            path='/card-templates/create'
            element={
              <AdminOwnerRoute>
                <WalletCard />
              </AdminOwnerRoute>
            }
          />
          <Route
            path='/card-templates/edit/:cardId'
            element={
              <AdminOwnerRoute>
                <WalletCard />
              </AdminOwnerRoute>
            }
          />
          <Route
            path='/card-templates/success/:cardId'
            element={
              <AdminOwnerRoute>
                <WalletCardSuccessPage />
              </AdminOwnerRoute>
            }
          />
          <Route
            path='/card-templates/detail/:cardId'
            element={
              <AdminOwnerRoute>
                <WalletCardSuccessPage />
              </AdminOwnerRoute>
            }
          />
          <Route path='/report-wallet-card' element={<DetailWalletCardReport />} />
          <Route path='/contact-collection' element={<TabContactCollection />} />
          <Route path='/record-list/:id' element={<RecordList />} />
          <Route path='/team-list' element={<TeamList />} />
          <Route path='/wallet-nurture-flow' element={<FlowList />} />

          {/* promo action */}
          <Route path={RoutePaths.promoAction} element={<PromoActionList />} />

          {/* <Route path='*' /> */}

          <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
      </Routes>
    </>
  )
}

export default UserRoutes